import React, { useCallback, useContext, useEffect } from "react";
import LocomotiveScroll from 'locomotive-scroll';
import { ScrollContext } from "../context/scrollContext";

export default function SmoothScroll({ options, className, children, ...props }) {

    const { scrollInstance, scrollActions } = useContext(ScrollContext)

    const scollContainer = useCallback((node) => {
        if (node !== null && document) {
            const updatedOptions = Object.assign({
                el: node,
                smooth: true,
                tablet: {
                    smooth: false,
                },
                smartphone: {
                    smooth: false
                }
            }, options)
            const scroll = new LocomotiveScroll(updatedOptions)
            scrollInstance.current = scroll
        }
    }, [options, scrollInstance])

    useEffect(() => {
        window.addEventListener('resize', () => { setTimeout(() => scrollActions.update, 0) })
        return () => window.removeEventListener('resize', () => { setTimeout(() => scrollActions.update, 0) })
    }, [scrollActions.update])

    return (
        <div id='scroll-container' className={className} ref={scollContainer} {...props} data-scroll-container data-scroll >
            {children}
        </div>
    )


}



